export default __webpack_public_path__ + "static/media/np.eea07641.svg";